document.documentElement.classList.remove('no-js');

(() => {
  const api=window.QXTheme||{};
  const root=api.root||((window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/');
  const qs=api.qs||((s,ctx=document)=>ctx.querySelector(s));
  const qsa=api.qsa||((s,ctx=document)=>[...ctx.querySelectorAll(s)]);
  const qxSafeStorageRead=api.safeStorageRead||((key,validator=()=>true,fallback=null)=>{
    try{
      const raw=localStorage.getItem(key);
      if(raw===null)return fallback;
      const parsed=JSON.parse(raw);
      return validator(parsed)?parsed:fallback;
    }catch(_){return fallback}
  });
  const qxSafeStorageWrite=api.safeStorageWrite||((key,value)=>{
    try{localStorage.setItem(key,JSON.stringify(value));return true}catch(_){return false}
  });
  const qxGetProductHtml=api.getProductHtml||(async url=>{
    const response=await fetch(url,{headers:{Accept:'text/html'}});
    if(!response.ok)throw new Error('product-request-failed');
    return response.text();
  });
  const showUxToast=api.showToast||(()=>{});

/* QX 2.3.0 — Wishlist drawer */
  const renderWishlistDrawer = () => {
    const drawer = qs('[data-qx-wishlist-drawer]');
    if (!drawer || typeof qxReadArray !== 'function') return;
    const itemsWrap = qs('[data-qx-wishlist-drawer-items]', drawer);
    const empty = qs('[data-qx-wishlist-drawer-empty]', drawer);
    const count = qs('[data-qx-wishlist-drawer-count]', drawer);
    const items = qxReadArray('qxWishlistProducts');

    if (count) count.textContent = items.length ? `${items.length} saved product${items.length===1?'':'s'}` : '';
    if (empty) empty.hidden = items.length > 0;
    if (!itemsWrap) return;
    itemsWrap.innerHTML = '';

    items.forEach(item => {
      const row = document.createElement('article');
      row.className = 'qx-wishlist-drawer__item';

      if (item.image) {
        const img = document.createElement('img');
        img.src = item.image;
        img.alt = item.title || '';
        img.loading = 'lazy';
        row.appendChild(img);
      } else {
        const ph = document.createElement('div');
        ph.className = 'qx-wishlist-drawer__placeholder';
        row.appendChild(ph);
      }

      const body = document.createElement('div');
      const link = document.createElement('a');
      link.href = item.url || '#';
      link.textContent = item.title || '';
      body.appendChild(link);

      if (item.vendor) {
        const small = document.createElement('small');
        small.textContent = item.vendor;
        body.appendChild(small);
      }
      if (item.price) {
        const price = document.createElement('strong');
        price.textContent = item.price;
        body.appendChild(price);
      }

      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'qx-wishlist-drawer__remove';
      remove.dataset.qxWishlistDrawerRemove = item.handle;
      remove.setAttribute('aria-label', `Remove ${item.title || 'product'} from wishlist`);
      remove.textContent = '×';

      if (item.variantTitle && item.variantTitle !== 'Default Title') {
        const variant = document.createElement('small');
        variant.className = 'qx-wishlist-drawer__variant';
        variant.textContent = item.variantTitle;
        body.appendChild(variant);
      }
      const availability = document.createElement('small');
      availability.className = 'qx-wishlist-drawer__availability';
      availability.textContent = item.available === false ? 'Unavailable' : 'Saved variant';
      body.appendChild(availability);

      const controls = document.createElement('div');
      controls.className = 'qx-wishlist-drawer__controls';

      const qty = document.createElement('label');
      qty.className = 'qx-wishlist-drawer__qty';
      qty.innerHTML = '<span class="visually-hidden">Quantity</span><button type="button" data-qx-wishlist-qty-minus aria-label="Decrease quantity">−</button><input type="number" min="1" value="1" inputmode="numeric" data-qx-wishlist-qty-input aria-label="Quantity"><button type="button" data-qx-wishlist-qty-plus aria-label="Increase quantity">+</button>';
      controls.appendChild(qty);

      const move=document.createElement('button');
      move.type='button';
      move.className='qx-wishlist-drawer__move';
      move.dataset.qxWishlistMove=item.variantId||'';
      move.dataset.handle=item.handle||'';
      move.textContent='Move to cart';
      controls.appendChild(move);

      const changeVariant=document.createElement('button');
      changeVariant.type='button';
      changeVariant.className='qx-wishlist-drawer__change';
      changeVariant.dataset.qxWishlistChangeVariant=item.handle||'';
      changeVariant.textContent='Change variant';
      controls.appendChild(changeVariant);

      body.appendChild(controls);
      row.append(body, remove);
      itemsWrap.appendChild(row);
    });
  };

  const openWishlistDrawer = () => {
    const drawer = qs('[data-qx-wishlist-drawer]');
    if (!drawer) return;
    renderWishlistDrawer();
    drawer.hidden = false;
    document.body.classList.add('qx-wishlist-drawer-open');
    qs('.qx-wishlist-drawer__close', drawer)?.focus();
  };

  const closeWishlistDrawer = () => {
    const drawer = qs('[data-qx-wishlist-drawer]');
    if (!drawer) return;
    drawer.hidden = true;
    document.body.classList.remove('qx-wishlist-drawer-open');
  };

  /* QX 1.8.0–1.8.4 personalization + retention */
  const QX_WISHLIST_KEY='qxWishlistProducts',QX_COMPARE_KEY='qxCompareProducts',QX_CONTINUE_KEY='qxContinueShoppingUrl';
  const qxReadArray=key=>qxSafeStorageRead(key,Array.isArray,[]).filter(Boolean);
  const qxWriteArray=(key,items,eventName)=>{qxSafeStorageWrite(key,items);if(eventName)window.dispatchEvent(new CustomEvent(eventName,{detail:{items}}))};
  const qxProductFrom=el=>{const s=el.closest('[data-qx-product-card]')||el;return{handle:s.dataset.qxProductHandle||'',title:s.dataset.qxProductTitle||'',url:s.dataset.qxProductUrl||'',image:s.dataset.qxProductImage||'',price:s.dataset.qxProductPrice||'',vendor:s.dataset.qxProductVendor||'',highlight1:s.dataset.qxProductHighlight1||'',highlight2:s.dataset.qxProductHighlight2||'',variantId:s.dataset.qxProductVariantId||'',variantTitle:s.dataset.qxProductVariantTitle||'',available:s.dataset.qxProductAvailable!=='false',material:s.dataset.qxProductMaterial||'',dimensions:s.dataset.qxProductDimensions||'',weight:s.dataset.qxProductWeight||'',warranty:s.dataset.qxProductWarranty||''}};
  const syncWishlistButtons=()=>{const h=new Set(qxReadArray(QX_WISHLIST_KEY).map(i=>i.handle));qsa('[data-qx-wishlist-toggle]').forEach(b=>{const p=qxProductFrom(b),a=p.handle&&h.has(p.handle);b.setAttribute('aria-pressed',a?'true':'false');const l=qs('[data-qx-wishlist-label]',b);if(l)l.textContent=a?'Saved to wishlist':'Save to wishlist'})};
  const toggleWishlist=b=>{const p=qxProductFrom(b);if(!p.handle)return;let a=qxReadArray(QX_WISHLIST_KEY),exists=a.some(i=>i.handle===p.handle);a=exists?a.filter(i=>i.handle!==p.handle):[p,...a.filter(i=>i.handle!==p.handle)].slice(0,50);qxWriteArray(QX_WISHLIST_KEY,a,'qx:wishlist-change');syncWishlistButtons();renderWishlistDrawer();showUxToast(exists?'Removed from wishlist':'Saved to wishlist');if(!exists)openWishlistDrawer()};
  const syncCompareButtons=()=>{const h=new Set(qxReadArray(QX_COMPARE_KEY).map(i=>i.handle));qsa('[data-qx-compare-toggle]').forEach(b=>{const p=qxProductFrom(b),a=p.handle&&h.has(p.handle);b.setAttribute('aria-pressed',a?'true':'false');const l=qs('[data-qx-compare-label]',b);if(l)l.textContent=a?'Added to compare':'Compare'})};
  const ensureCompareTray=()=>{let t=qs('[data-qx-compare-tray]');if(t)return t;t=document.createElement('aside');t.className='qx-compare-tray';t.dataset.qxCompareTray='';t.setAttribute('aria-label','Product comparison');t.innerHTML=`<div class="qx-compare-tray__inner"><div><strong>Compare products</strong><span data-qx-compare-tray-count></span></div><div class="qx-compare-tray__items" data-qx-compare-tray-items></div><a class="qx-compare-tray__view" href="${document.documentElement.dataset.qxCompareUrl||'/pages/compare'}">Compare now</a><button type="button" class="qx-compare-tray__clear" data-qx-compare-clear aria-label="Clear comparison">×</button></div>`;document.body.appendChild(t);t.addEventListener('click',e=>{const r=e.target.closest('[data-qx-compare-remove]');if(r){qxWriteArray(QX_COMPARE_KEY,qxReadArray(QX_COMPARE_KEY).filter(i=>i.handle!==r.dataset.qxCompareRemove),'qx:compare-change');syncCompareButtons();renderCompareTray();return}if(e.target.closest('[data-qx-compare-clear]')){qxWriteArray(QX_COMPARE_KEY,[],'qx:compare-change');syncCompareButtons();renderCompareTray()}});return t};
  const renderCompareTray=()=>{const a=qxReadArray(QX_COMPARE_KEY),t=ensureCompareTray();t.classList.toggle('is-visible',a.length>0);const c=qs('[data-qx-compare-tray-count]',t),l=qs('[data-qx-compare-tray-items]',t);if(c)c.textContent=`${a.length} selected`;if(!l)return;l.innerHTML='';a.forEach(i=>{const x=document.createElement('div');x.className='qx-compare-tray__item';if(i.image){const im=document.createElement('img');im.src=i.image;im.alt='';x.appendChild(im)}const s=document.createElement('span');s.textContent=i.title||'';const b=document.createElement('button');b.type='button';b.dataset.qxCompareRemove=i.handle;b.setAttribute('aria-label',`Remove ${i.title||'product'}`);b.textContent='×';x.append(s,b);l.appendChild(x)})};
  const toggleCompare=b=>{const p=qxProductFrom(b);if(!p.handle)return;let a=qxReadArray(QX_COMPARE_KEY),exists=a.some(i=>i.handle===p.handle),max=Number(document.documentElement.dataset.qxCompareMax||4);if(exists)a=a.filter(i=>i.handle!==p.handle);else{if(a.length>=max){a=a.slice(-(max-1));showUxToast(`Compare is limited to ${max} products`)}a.push(p)}qxWriteArray(QX_COMPARE_KEY,a,'qx:compare-change');syncCompareButtons();renderCompareTray();showUxToast(exists?'Removed from compare':'Added to compare')};
  const initContinueShopping=()=>{if(location.pathname.includes('/collections/')){try{localStorage.setItem(QX_CONTINUE_KEY,location.href)}catch(_){}}qsa('[data-qx-continue-shopping]').forEach(a=>{try{const u=localStorage.getItem(QX_CONTINUE_KEY);if(u)a.href=u}catch(_){}})};
  const initPersonalization=()=>{syncWishlistButtons();syncCompareButtons();renderCompareTray();initContinueShopping()};


  /* QX 2.6.1 — Cart Product Quick View */
  const ensureCartProductQuickViewDialog=()=>{
    let d=qs('[data-qx-cart-qv-dialog]');
    if(d)return d;
    d=document.createElement('dialog');
    d.className='qx-cart-product-qv';
    d.dataset.qxCartQvDialog='';
    d.setAttribute('aria-labelledby','QXSharedQuickViewTitle');
    d.innerHTML=`
      <div class="qx-cart-product-qv__shell">
        <header class="qx-cart-product-qv__header">
          <div>
            <small>QUICK VIEW</small>
            <strong id="QXSharedQuickViewTitle" data-qx-cart-qv-title>Product</strong>
          </div>
          <button type="button" data-qx-cart-qv-close aria-label="Close quick view">×</button>
        </header>
        <div class="qx-cart-product-qv__body" data-qx-cart-qv-body aria-live="polite">
          <div class="qx-cart-product-qv__loading">Loading product…</div>
        </div>
      </div>`;
    document.body.appendChild(d);
    d.addEventListener('click',e=>{if(e.target===d)d.close()});
    d.addEventListener('close',()=>{const t=d._qxTrigger;if(t?.isConnected)t.focus();d._qxTrigger=null;});
    return d;
  };

  const qxCartQvEsc=s=>String(s||'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));

  const openCartProductQuickView=async trigger=>{
    const productUrl=trigger?.dataset?.productUrl||trigger?.getAttribute?.('href');
    if(!productUrl){showUxToast('Product could not be opened');return}
    const d=ensureCartProductQuickViewDialog();
    d._qxTrigger=trigger;
    const body=qs('[data-qx-cart-qv-body]',d);
    const titleEl=qs('[data-qx-cart-qv-title]',d);
    body.innerHTML='<div class="qx-cart-product-qv__loading">Loading product…</div>';
    d.dataset.productUrl=productUrl;
    d.setAttribute('aria-busy','true');
    if(!d.open)d.showModal();

    const renderProduct=async url=>{
      const html=await qxGetProductHtml(url,{timeout:6500,retry:1});
      const doc=new DOMParser().parseFromString(html,'text/html');
      const pdp=qs('[data-product-root]',doc);
      if(!pdp)throw new Error('Product information unavailable');

      const title=qs('h1',pdp)?.textContent?.trim()||trigger.closest('.qx-cart-line')?.querySelector('.qx-cart-line__title')?.textContent?.trim()||'Product';
      const price=qs('[data-product-price]',pdp)?.textContent?.trim()||'';
      const compare=qs('[data-product-compare]',pdp)?.textContent?.trim()||'';
      const image=qs('[data-product-media-track] img,.qx-pdp__media img,img',pdp)?.getAttribute('src')||'';
      const variantInput=qs('[data-variant-id]',pdp);
      const variantId=variantInput?.value||'';
      const addButton=qs('[name="add"],[data-product-submit],button[type="submit"]',pdp);
      const available=!!variantId && !(addButton?.disabled);
      const selectors=qsa('select[data-option-select],select[data-option-position]',pdp);

      titleEl.textContent=title;
      body.innerHTML='';

      const wrap=document.createElement('div');
      wrap.className='qx-cart-product-qv__content';

      const media=document.createElement('div');
      media.className='qx-cart-product-qv__media';
      if(image){
        const img=document.createElement('img');
        img.src=image;
        img.alt=title;
        img.loading='eager';
        media.appendChild(img);
      }

      const info=document.createElement('div');
      info.className='qx-cart-product-qv__info';
      const heading=document.createElement('h3');
      heading.textContent=title;
      const priceRow=document.createElement('div');
      priceRow.className='qx-cart-product-qv__price';
      priceRow.innerHTML=`<strong data-qx-cart-qv-price>${qxCartQvEsc(price)}</strong>${compare?`<s>${qxCartQvEsc(compare)}</s>`:''}`;
      info.append(heading,priceRow);

      const picker=document.createElement('div');
      picker.className='qx-cart-product-qv__options';
      selectors.forEach(sel=>{
        const group=document.createElement('label');
        const sourceLabel=sel.closest('.qx-pdp__option')?.querySelector('label,.qx-pdp__option-label')?.textContent?.trim()||sel.getAttribute('aria-label')||'Option';
        const label=document.createElement('span');
        label.textContent=sourceLabel;
        const copy=sel.cloneNode(true);
        copy.removeAttribute('id');
        copy.dataset.qxCartQvOption='';
        group.append(label,copy);
        picker.appendChild(group);
      });
      if(selectors.length)info.appendChild(picker);

      const hidden=document.createElement('input');
      hidden.type='hidden';
      hidden.dataset.qxCartQvVariant='';
      hidden.value=variantId;
      info.appendChild(hidden);

      const qty=document.createElement('div');
      qty.className='qx-cart-product-qv__qty';
      qty.innerHTML='<button type="button" data-qx-cart-qv-minus aria-label="Decrease quantity">−</button><input type="number" min="1" max="99" value="1" inputmode="numeric" data-qx-cart-qv-qty aria-label="Quantity"><button type="button" data-qx-cart-qv-plus aria-label="Increase quantity">+</button>';
      info.appendChild(qty);

      const actions=document.createElement('div');
      actions.className='qx-cart-product-qv__actions';
      const add=document.createElement('button');
      add.type='button';
      add.dataset.qxCartQvAdd='';
      add.className='qx-btn qx-btn--dark';
      add.textContent=available?'Add to cart':'Unavailable';
      add.disabled=!available;
      const full=document.createElement('a');
      full.href=productUrl;
      full.className='qx-btn qx-btn--outline';
      full.textContent='View full details';
      actions.append(add,full);
      info.appendChild(actions);

      const status=document.createElement('p');
      status.className='qx-cart-product-qv__status';
      status.dataset.qxCartQvStatus='';
      status.setAttribute('role','status');
      info.appendChild(status);

      wrap.append(media,info);
      body.appendChild(wrap);

      const resolve=async()=>{
        const optionIds=qsa('[data-qx-cart-qv-option]',picker).map(s=>s.selectedOptions?.[0]?.dataset.optionValueId||s.value).filter(Boolean);
        const u=new URL(productUrl,location.origin);
        u.searchParams.delete('variant');
        if(optionIds.length)u.searchParams.set('option_values',optionIds.join(','));
        body.setAttribute('aria-busy','true');
        try{
          const resolved=await qxResolveProductVariant(productUrl,optionIds,{timeout:6500,retry:1});
          hidden.value=resolved.id;
          qs('[data-qx-cart-qv-price]',info).textContent=resolved.price;
          add.disabled=!resolved.id||!resolved.available;
          add.textContent=add.disabled?'Unavailable':'Add to cart';
        }finally{
          body.removeAttribute('aria-busy');
        }
      };
      qsa('[data-qx-cart-qv-option]',picker).forEach(sel=>sel.addEventListener('change',resolve));
    };

    try{
      await renderProduct(productUrl);
    }catch(_){
      body.innerHTML=`<div class="qx-cart-product-qv__error"><strong>Quick view unavailable</strong><p>Open the product page to view current options.</p><a class="qx-btn qx-btn--dark" href="${qxCartQvEsc(productUrl)}">View product</a></div>`;
    }finally{
      d.removeAttribute('aria-busy');
    }
  };

  const ensureCartVariantDialog=()=>{let d=qs('[data-qx-cart-variant-dialog]');if(d)return d;d=document.createElement('dialog');d.className='qx-cart-variant-dialog';d.dataset.qxCartVariantDialog='';d.innerHTML='<div class="qx-cart-variant-dialog__shell"><header><strong>Change variant</strong><button type="button" data-qx-cart-variant-close aria-label="Close">×</button></header><div data-qx-cart-variant-body>Loading…</div><footer><button type="button" data-qx-cart-variant-save>Update cart</button></footer></div>';document.body.appendChild(d);return d};
  const openCartVariantChooser=async trigger=>{const d=ensureCartVariantDialog(),body=qs('[data-qx-cart-variant-body]',d);d.dataset.lineKey=trigger.dataset.lineKey||'';d.dataset.lineQuantity=trigger.dataset.lineQuantity||'1';d.dataset.productUrl=trigger.dataset.productUrl||'';body.textContent='Loading options…';if(!d.open)d.showModal();try{const html=await fetch(trigger.dataset.productUrl,{headers:{Accept:'text/html'}}).then(r=>r.text());const doc=new DOMParser().parseFromString(html,'text/html'),rootEl=qs('[data-product-root]',doc);if(!rootEl)throw new Error();body.innerHTML='';const picker=document.createElement('div');picker.className='qx-cart-variant-dialog__picker';qsa('select[data-option-select],select[data-option-position]',rootEl).forEach(sel=>{const lab=sel.previousElementSibling?.cloneNode(true),c=sel.cloneNode(true);c.dataset.qxCartVariantOption='';if(lab)picker.appendChild(lab);picker.appendChild(c)});const variant=qs('[data-variant-id]',rootEl),hidden=document.createElement('input');hidden.type='hidden';hidden.dataset.qxCartVariantId='';hidden.value=variant?.value||'';picker.appendChild(hidden);body.appendChild(picker);const resolve=async()=>{const optionIds=qsa('[data-qx-cart-variant-option]',picker).map(s=>s.selectedOptions?.[0]?.dataset.optionValueId||s.value).filter(Boolean);const u=new URL(trigger.dataset.productUrl,location.origin);u.searchParams.delete('variant');if(optionIds.length)u.searchParams.set('option_values',optionIds.join(','));const txt=await fetch(u,{headers:{Accept:'text/html'}}).then(r=>r.text()),x=new DOMParser().parseFromString(txt,'text/html');hidden.value=qs('[data-variant-id]',x)?.value||''};qsa('[data-qx-cart-variant-option]',picker).forEach(x=>x.addEventListener('change',resolve))}catch(_){body.textContent='Variant options could not be loaded. Open the product page to change options.'}};
  /* QX 2.4.0 feature-gap runtime */
  const updateWishlistCounts=()=>{const n=qxReadArray('qxWishlistProducts').length;qsa('[data-qx-wishlist-count]').forEach(e=>e.textContent=n)};
  window.addEventListener('qx:wishlist-change',()=>{updateWishlistCounts();renderWishlistDrawer?.()});
  const ensureWishlistVariantDialog=()=>{
    let d=qs('[data-qx-wishlist-variant-dialog]');
    if(d)return d;
    d=document.createElement('dialog');
    d.className='qx-wishlist-variant-dialog';
    d.dataset.qxWishlistVariantDialog='';
    d.innerHTML='<div class="qx-wishlist-variant-dialog__shell"><header><strong>Change variant</strong><button type="button" data-qx-wishlist-variant-close aria-label="Close">×</button></header><div data-qx-wishlist-variant-body>Loading options…</div><footer><button type="button" data-qx-wishlist-variant-save>Save variant</button></footer></div>';
    document.body.appendChild(d);
    return d;
  };

  const openWishlistVariantChooser=async trigger=>{
    const item=qxReadArray(QX_WISHLIST_KEY).find(i=>i.handle===trigger.dataset.qxWishlistChangeVariant);
    if(!item?.url){showUxToast('Product URL unavailable');return}
    const d=ensureWishlistVariantDialog(),body=qs('[data-qx-wishlist-variant-body]',d);
    d.dataset.handle=item.handle||'';
    d.dataset.productUrl=item.url||'';
    body.textContent='Loading options…';
    if(!d.open)d.showModal();
    try{
      const html=await fetch(item.url,{headers:{Accept:'text/html'}}).then(r=>r.text());
      const doc=new DOMParser().parseFromString(html,'text/html'),rootEl=qs('[data-product-root]',doc);
      if(!rootEl)throw new Error();
      body.innerHTML='';
      const picker=document.createElement('div');
      picker.className='qx-wishlist-variant-dialog__picker';
      qsa('select[data-option-select],select[data-option-position]',rootEl).forEach(sel=>{
        const label=sel.previousElementSibling?.cloneNode(true),copy=sel.cloneNode(true);
        copy.dataset.qxWishlistVariantOption='';
        if(label)picker.appendChild(label);
        picker.appendChild(copy);
      });
      const variant=qs('[data-variant-id]',rootEl);
      const hidden=document.createElement('input');
      hidden.type='hidden';
      hidden.dataset.qxWishlistVariantId='';
      hidden.value=variant?.value||'';
      picker.appendChild(hidden);
      body.appendChild(picker);

      const resolve=async()=>{
        const optionIds=qsa('[data-qx-wishlist-variant-option]',picker).map(s=>s.selectedOptions?.[0]?.dataset.optionValueId||s.value).filter(Boolean);
        const u=new URL(item.url,location.origin);
        u.searchParams.delete('variant');
        if(optionIds.length)u.searchParams.set('option_values',optionIds.join(','));
        const txt=await fetch(u,{headers:{Accept:'text/html'}}).then(r=>r.text());
        const x=new DOMParser().parseFromString(txt,'text/html'),pdp=qs('[data-product-root]',x);
        hidden.value=qs('[data-variant-id]',pdp)?.value||'';
        d.dataset.variantTitle=qs('[data-selected-variant-title]',pdp)?.textContent?.trim()||'';
        d.dataset.variantAvailable=qs('[data-add-to-cart]',pdp)?.disabled?'false':'true';
        d.dataset.variantPrice=qs('[data-product-price]',pdp)?.textContent?.trim()||item.price||'';
      };
      qsa('[data-qx-wishlist-variant-option]',picker).forEach(x=>x.addEventListener('change',resolve));
    }catch(_){
      body.textContent='Variant options could not be loaded. Open the product page to change options.';
    }
  };

  const initQx240=()=>{
    updateWishlistCounts();
    qsa('.qx-section').forEach(s=>{const a=document.documentElement.dataset.qxAnimation;if(a&&a!=='none')s.dataset.qxSectionAnimate=a});
    let recent=qxReadArray('qxRecentlyViewedProducts')
    qsa('[data-qx-cart-empty-recent]').forEach(box=>{const list=qs('[data-qx-cart-empty-recent-list]',box);if(recent.length&&list&&!list.children.length){box.hidden=false;recent.slice(0,6).forEach(i=>{const a=document.createElement('a');a.href=i.url||'#';if(i.image){const im=document.createElement('img');im.src=i.image;im.alt=i.title||'';a.appendChild(im)}const s=document.createElement('span');s.textContent=i.title||'';a.appendChild(s);list.appendChild(a)})}});
    qsa('[data-qx-search-recent-products]').forEach(box=>{const list=qs('[data-qx-search-recent-products-list]',box);if(recent.length&&list&&!list.children.length){box.hidden=false;recent.slice(0,6).forEach(i=>{const a=document.createElement('a');a.href=i.url||'#';if(i.image){const im=document.createElement('img');im.src=i.image;im.alt=i.title||'';a.appendChild(im)}const st=document.createElement('strong');st.textContent=i.title||'';a.appendChild(st);list.appendChild(a)})}});
    qsa('[data-qx-cart-complementary]').forEach(async box=>{if(box.dataset.loaded==='true'||!box.dataset.productId)return;box.dataset.loaded='true';try{const url=`${root}recommendations/products?section_id=qx-cart-complementary&product_id=${encodeURIComponent(box.dataset.productId)}&intent=complementary`;const html=await fetch(url,{headers:{Accept:'text/html'}}).then(r=>r.text());box.innerHTML=html}catch(_){}});
  };

  window.QXCommerce=Object.assign(window.QXCommerce||{},{
    QX_WISHLIST_KEY,
    qxReadArray,
    qxWriteArray,
    renderWishlistDrawer,
    openWishlistDrawer,
    closeWishlistDrawer,
    syncWishlistButtons,
    toggleWishlist,
    toggleCompare,
    initPersonalization,
    openCartProductQuickView,
    openCartVariantChooser,
    openWishlistVariantChooser,
    initQx240
  });
})();
